import { lazy } from "react"
import { Navigate, RouteObject } from "react-router-dom"

import { Layout } from "../Layout"
import Unauthorized403 from "./4XX/403Unauthorized"
import { AccessDenied } from "../components/AccessDenied"
import NotFound404 from "./4XX/404NotFound"

const UserRoutes = lazy(() =>
  import("./user/routes").then((m) => ({ default: m.UserRoutes }))
)

const CompanyRoutes = lazy(() =>
  import("./office/company/routes").then((m) => ({ default: m.CompanyRoutes }))
)

const FiduciaryRoutes = lazy(() =>
  import("./office/fiduciary/routes").then((m) => ({
    default: m.FiduciaryRoutes,
  }))
)

// Shared: Security is under office but lives in user (lazy)
const Security = lazy(() =>
  import("./user/Security").then((m) => ({ default: m.Security }))
)

// Components (lazy)
const CompanyRegister = lazy(() =>
  import("../components/CompanyRegister").then((m) => ({
    default: m.CompanyRegister,
  }))
)
const InputMaskViewer = lazy(() =>
  import("../components/inputMask/InputMaskViewer").then((m) => ({
    default: m.InputMaskViewer,
  }))
)

// Office (lazy)
const FiduciaryRegister = lazy(() => import("./fiduciary/Register"))
const Office = lazy(() => import("./office/Office"))
const Management = lazy(() =>
  import("./office/fiduciary/management/Management").then((m) => ({
    default: m.Management,
  }))
)
const Users = lazy(() =>
  import("./office/fiduciary/management/Users").then((m) => ({
    default: m.Users,
  }))
)
const CaptureMailDashboard = lazy(() =>
  import("./office/fiduciary/management/CaptureMailDashboard").then((m) => ({
    default: m.CaptureMailDashboard,
  }))
)
const AccountingType = lazy(() =>
  import("./office/company/AccountingType").then((m) => ({
    default: m.AccountingType,
  }))
)
// Public (non-logged) brokered Fulll/Inexweb OAuth page.
const FulllOauthBroker = lazy(() =>
  import("./fulll-oauth/FulllOauthBroker").then((m) => ({
    default: m.FulllOauthBroker,
  }))
)

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Navigate to="/user/login" replace />,
      },
      {
        path: "input_mask_viewer/:initial_full_document_id",
        children: [
          {
            index: true,
            element: <InputMaskViewer />,
          },
        ],
      },
      {
        path: "user/*",
        element: <UserRoutes />,
      },
      {
        path: "fiduciary/register",
        element: <FiduciaryRegister />,
      },
      {
        path: "fulll-oauth",
        element: <FulllOauthBroker />,
      },
      {
        path: "office/*",
        element: <Office />,
        children: [
          {
            index: true,
            element: <Navigate to={"fiduciary/companies"} />,
          },
          {
            path: "security",
            element: <Security />,
          },
          {
            path: "management",
            element: <Management />,
            children: [
              {
                index: true,
                element: <Navigate to={"users"} />,
              },
              {
                path: "users",
                element: <Users />,
              },
              {
                path: "capture_mail",
                element: <CaptureMailDashboard />,
              },
            ],
          },
          {
            path: "fiduciary/company_accounting_type",
            element: <AccountingType />,
          },
          {
            path: "fiduciary/register_company/:account_type",
            element: <CompanyRegister />,
          },
          {
            path: "fiduciary/*",
            element: <FiduciaryRoutes />,
          },
          {
            path: "company/*",
            element: <CompanyRoutes />,
          },
          {
            path: "*",
            element: <Navigate to={"/not_found"} />,
          },
        ],
      },
      {
        path: "unauthorized",
        element: <Unauthorized403 />,
      },
      {
        path: "/access_denied",
        element: <AccessDenied />,
      },
      {
        path: "*",
        element: <NotFound404 />,
      },
    ],
  },
]
